import { FC, memo, ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router";
import { auth } from '../../firebase';
import { useDispatch, useSelector } from "react-redux";
import { login, logout, selectAuth } from "../../features/auth.slice";
import { signInWithCustomToken } from "firebase/auth";
import { getTenantId } from "../../utility/FireStoreUtility";
import { useLocation, useNavigate } from "react-router-dom";
import { Spiner } from "../../components/spinner/Spiner";
import { outInfoLog } from "../../api/outGcpLogging";

type Props = {
  children: ReactNode
}

export const AuthUserRoute: FC<Props> = memo((props) => {
  const { children } = props;
  const dispatch = useDispatch();
  const user = useSelector(selectAuth);
  const [authChecked, setAuthChecked] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // WebViewからの遷移時の認証処理
  useEffect(() => {
    (async () => {
      if(location.search !== ""){
        const query = new URLSearchParams(location.search);
        const queryTenantId = query.get("tenantId") ?? "";
        const queryToken = query.get("token") ?? "";
        if (queryToken !== "" && queryTenantId !== "") {
          try {
            const tenantIdValue = await getTenantId(queryTenantId);
            auth.tenantId = tenantIdValue.data as string;
            await signInWithCustomToken(auth, queryToken);
            sessionStorage.setItem("jwt", queryToken);
            // dispatch は onAuthStateChangedで実行
            // URLからtokenとtenantIdを削除
            const cleanParams = new URLSearchParams(location.search);
            cleanParams.delete("token");
            cleanParams.delete("tenantId");
            navigate(`${location.pathname}?${cleanParams.toString()}`, { replace: true });
          } catch(error) {
            await outInfoLog(error, queryTenantId);
            console.log(error);
            navigate("/portal/login");
          }
        }
      }
    })();
  }, [location.search, navigate]);

  // Firebaseの認証状態を監視
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
      if (authUser) {
        dispatch(login({
          uid: authUser.uid,
          photoUrl: authUser.photoURL,
          displayName: authUser.displayName,
        }));
      } else {
        dispatch(logout());
      }
      setAuthChecked(true);
    });
    return () => unsubscribe();
  }, [dispatch]);
  return (
    <>
      {!authChecked ? (
        <>
          <Spiner />
        </>
      ) : (
        <>{user.uid ? (
            <>
              {children}
            </>
          ) : (
            <>{location.search !== "" ? (
              <>
                <Spiner />
              </>
            ) : (
              <>
                <Navigate to="/portal/login" />
              </>
            )}
            </>
          )}
        </>
      )}
    </>
  );
});